import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import ProspectModel from "../../models/prospect";
import { DataTable } from "../../components";
import { ProspectInterface } from "../../interfaces";

const ViewProspects = () => {
  const [prospects, setProspects] = useState<ProspectInterface[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [isLoading, setIsLoading] = useState(false);

  const fetchProspects = async (pageIndex: number, pageSize: number) => {
    try {
      setIsLoading(true);
      const skip = pageIndex * pageSize;

      const resp = await ProspectModel.fetchAll<any>({
        $skip: skip,
        $limit: pageSize,
        $sort: { createdAt: -1 },
      });

      return {
        rows: resp.data.filter((item: any) => item.email),
        totalCount: resp.total,
      };
    } catch (error: any) {
      throw new Error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProspects(pagination.pageIndex, pagination.pageSize).then((res) => {
      setProspects(res.rows);
      setTotalCount(res.totalCount);
    });
  }, [pagination]);


  return <DataTable 
    columns={ProspectModel.getColumns()} 
    data={prospects}  
    pagination={pagination}
    onPaginationChange={setPagination}
    totalRowCount={totalCount}
    loading={isLoading}
  />;
};

export default ViewProspects;
